import { datadogRum } from '@datadog/browser-rum';
import axios from 'axios';

import scrubURL from '@app/libs/scrubURL';

export async function activateMonitoring() {
  if (process.env.REACT_APP_MODUSIGN_ENV !== 'development') {
    const version =
      (await axios('/version.json')
        .then((res) => res.data.version)
        .catch(() => null)) ?? null;

    datadogRum.init({
      applicationId: 'bdb0f00e-78a0-4a53-a54f-ea803deb298b',
      clientToken: 'puba117a73b88c95cc2a6bece0858bcf2e4',
      site: 'datadoghq.com',
      service: 'modusign-client-app',
      env:
        // TODO(@taehwanno): REACT_APP_MODUSIGN_ENV가 stage-default로 변경된다면 아래 조건문 제거 가능
        process.env.REACT_APP_MODUSIGN_ENV === 'stage'
          ? 'stage-default'
          : process.env.REACT_APP_MODUSIGN_ENV, // 'production', 'stage', 'preview'
      sessionSampleRate: process.env.REACT_APP_MODUSIGN_ENV === 'production' ? 10 : 100, // 전체 session 중 샘플링하는 비율.
      sessionReplaySampleRate: 100, // sessionSampleRate에 대한 비율로서, 샘플링된 세션 중 Replay 세션으로서 적용할 비율.
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      version,
      defaultPrivacyLevel: 'mask',
      trackFrustrations: true,
      enableExperimentalFeatures: ['clickmap'],
      traceSampleRate: 10,
      allowedTracingUrls: [/https:\/\/.*\.modusign\.co\.kr/],
      beforeSend: (log) => {
        log.view.url = scrubURL(log.view.url);
        log.view.referrer &&= scrubURL(log.view.referrer);
      },
    });
  }

  datadogRum.startSessionReplayRecording();
}

export function setRumUser(user: { id: string; email?: string; name?: string } | null) {
  if (user) {
    datadogRum.setUser({
      id: user.id,
      email: user.email,
      name: user.name,
    });
    // 서버에서 userId를 context에 설정해서 서버, 클라이언트 로그를 한번에 검색하기 위해 global context에도 설정합니다.
    datadogRum.setGlobalContext({
      metadata: {
        userId: user.id,
        userEmail: user.email,
        userName: user.name,
      },
    });
  } else {
    datadogRum.clearUser();
    datadogRum.clearGlobalContext();
  }
}
